// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2oUeS","clinicsSelect":"TableHeading_clinicsSelect__3rpDs"};